import React from 'react'
import Button from './Button'
import WhatsAppButton from './WhatsAppButton'
import { useContactAction } from '../hooks/useContactAction'

interface ContactButtonProps {
  label?: string
  redirectToTarget?: boolean
  componentName?: string
  description?: string
  targetId?: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
  colorSchema?: 'primary' | 'secondary' | 'styled'
  style?: React.CSSProperties
}

const ContactButton = ({
  label = 'Contratar',
  redirectToTarget = false,
  componentName = 'ContactButton',
  description,
  targetId,
  className = 'w-full bg-white/80 border-l-white border-l-2 border-t-white border-t-2',
  size = 'lg',
  colorSchema = 'styled',
  style,
}: ContactButtonProps) => {
  const { handleClick } = useContactAction({ component: componentName, description, targetId })

  const button = (
    <Button colorSchema={colorSchema} className={className} size={size} style={style} onClick={() => handleClick(redirectToTarget)}>
      {label}
    </Button>
  )

  return (
    <div className='w-full'>
      {redirectToTarget ? button : <WhatsAppButton onClick={() => handleClick(redirectToTarget)}>{button}</WhatsAppButton>}
    </div>
  )
}

export default ContactButton
